import { apiUrl } from './apiBase';

const ENDPOINT = '/api/public/telemetry/pageview';

export type TrackedApp = 'viewer' | 'organizer' | 'display';

export function trackPageView(app: TrackedApp, path: string): void {
  const payload = JSON.stringify({
    app,
    path,
    referrer: document.referrer === '' ? null : document.referrer,
  });
  const url = apiUrl(ENDPOINT);

  if (typeof navigator.sendBeacon === 'function') {
    navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));

    return;
  }

  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: payload,
    keepalive: true,
  }).catch(() => undefined);
}
